import React from 'react';
import Modal from '../../../components/Utils/ModalShow';
const PayslipProgressModal = ({ progress }) => (
    <Modal
        isOpen={progress.total > 0}
        onClose={() => {}}
        title="Traitement en cours..."
        showCloseButton={false}
    >
        <div className="p-8 flex flex-col items-center">
            <div className="w-12 h-12 border-4 border-[--color-primary]/20 border-t-[--color-primary] rounded-full animate-spin mb-6"></div>
            <p className="text-gray-600 mb-4">
                {progress.current} / {progress.total} employés traités
            </p>
            <div className="w-full bg-gray-200 rounded-full h-2">
                <div 
                    className="bg-[--color-primary] h-2 rounded-full transition-all duration-300"
                    style={{ width: `${(progress.current / progress.total) * 100}%` }}
                ></div>
            </div>
        </div>
    </Modal>
);

export default PayslipProgressModal;